ready().then(function() {

    /**
     *  On several page templates are slides shown in featured/highlight cards. They all have in common that they have a text description
     *  On several device widths our description text lenght must be limited to an X no. of characters
     *  In our card-featured twig file the limit of the description/excerpt is set to a high no. of characters
     */

    window.trimFeaturedSliderDescriptions = () => {

        $('.card-featured .highlight-book-description').each(function() {
            const desc = this.innerHTML.trim();
            const titleLength = this.parentNode.children[0].innerText.length;
            var maxlengthDesc;

            if(this.parentNode.children[1].classList.contains('highlight-book-author')) {
                var subTitleLength = this.parentNode.children[1].innerText.length;
            }

            if (mediaBreakPointMinSmMaxMd.matches === true && this.classList.contains('highlight-book-description-tablet') ) {

                if(titleLength > 30 && titleLength < 53) {
                    maxlengthDesc = 43;
                } else if (titleLength >= 53) {
                    this.classList.add('is-hidden') // then the description may be hidden
                } else if (subTitleLength >= 37) {
                    this.classList.add('is-hidden')
                } else {
                    maxlengthDesc = 80;
                }
            }
            if (mediaBreakPointMinLg.matches === true && this.classList.contains('highlight-book-description-default')) {
                if(titleLength > 40 && titleLength < 85) {
                    maxlengthDesc = 170;
                } else if (titleLength >= 85) {
                    this.classList.add('is-hidden')
                } else if (subTitleLength >= 85) {
                    this.classList.add('is-hidden')
                } else {
                    maxlengthDesc = 220;
                }
            }

            let trimmeddesc = desc.trim().substr(0, maxlengthDesc);
            // re-trim if we are in the middle of a word
            trimmeddesc = trimmeddesc.substr(0, Math.min(trimmeddesc.length, trimmeddesc.lastIndexOf(" ")));
            // render the trimmed author description

            if(desc.length >= maxlengthDesc) {
                this.innerHTML = trimmeddesc + '...';
            }
        });
    };

    trimFeaturedSliderDescriptions();
});